import { ExtendCurrency } from 'src/enums'
import {
  ReceiptAttachmentModel,
  ReceiptAttachmentResponse,
} from 'src/models/receiptAttachment.models'

export enum ExpenseReportStatus {
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Reviewed = 'REVIEWED',
  Rejected = 'REJECTED',
  Paid = 'PAID',
}

export enum ExpenseStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}

export enum ExpenseReportManagerReviewStatus {
  Mixed = 'MIXED',
  Reviewed = 'REVIEWED',
  Rejected = 'REJECTED',
}

export enum ExpenseManagerReviewStatus {
  Reviewed = 'REVIEWED',
  Rejected = 'REJECTED',
}

export enum ExpenseType {
  General = 'GENERAL',
  Mileage = 'MILEAGE',
}

export interface ExpenseReportResponse {
  id: string
  employee: string
  employeeId: string
  deactivatedUser?: boolean
  reportName: string
  status: ExpenseReportStatus
  totalAmountSubmittedCents: number
  approvedAmountCents: number
  totalAmountSubmittedCurrency?: ExtendCurrency
  approvedAmountCurrency?: ExtendCurrency
  submittedAtDate?: string
  expenses?: ExpenseResponse[]
  createdAt: string
  managerReviewStatus?: ExpenseReportManagerReviewStatus
}

export class ExpenseReportModel {
  public id: string
  public employee: string
  public employeeId: string
  public deactivatedUser?: boolean
  public reportName: string
  public status: ExpenseReportStatus
  public totalAmountSubmittedCents: number
  public totalAmountSubmittedCurrency?: ExtendCurrency
  public approvedAmountCents: number
  public approvedAmountCurrency?: ExtendCurrency
  public submittedAtDate?: string
  public expenses: ExpenseModel[]
  public createdAt: string
  public managerReviewStatus?: ExpenseReportManagerReviewStatus

  public constructor(data: ExpenseReportResponse) {
    this.id = data.id
    this.employee = data.employee
    this.employeeId = data.employeeId
    this.deactivatedUser = data.deactivatedUser
    this.reportName = data.reportName
    this.status = data.status
    this.totalAmountSubmittedCents = data.totalAmountSubmittedCents
    this.totalAmountSubmittedCurrency = data.totalAmountSubmittedCurrency
    this.approvedAmountCents = data.approvedAmountCents
    this.approvedAmountCurrency = data.approvedAmountCurrency
    this.submittedAtDate = data.submittedAtDate
    this.expenses = data.expenses || []
    this.createdAt = data.createdAt
    this.managerReviewStatus = data.managerReviewStatus
  }
}

export interface ExpenseResponse {
  id: string
  expenseDate?: string
  expenseName?: string
  amountCents?: number
  currencyCode?: ExtendCurrency
  status: ExpenseStatus
  notes?: string
  receiptAttachments?: ReceiptAttachmentResponse[]
  expenseReportId: string
  type: ExpenseType
  distance?: number
  mileageRate?: number
  managerReviewStatus?: ExpenseManagerReviewStatus
  managerId?: string
}
export class ExpenseModel {
  public id: string
  public expenseDate?: string
  public expenseName?: string
  public amountCents?: number
  public currencyCode?: ExtendCurrency
  public status: ExpenseStatus
  public notes?: string
  public receiptAttachments?: ReceiptAttachmentResponse[]
  public expenseReportId: string
  public type: ExpenseType
  public distance?: number
  public mileageRate?: number
  public managerReviewStatus?: ExpenseManagerReviewStatus
  public managerId?: string

  public constructor(data: ExpenseResponse) {
    this.id = data.id
    this.expenseDate = data.expenseDate
    this.expenseName = data.expenseName
    this.amountCents = data.amountCents
    this.currencyCode = data.currencyCode
    this.status = data.status
    this.notes = data.notes
    this.receiptAttachments = data.receiptAttachments?.map(
      (att) => new ReceiptAttachmentModel(att),
    )
    this.expenseReportId = data.expenseReportId
    this.type = data.type
    this.distance = data.distance
    this.mileageRate = data.mileageRate
    this.managerReviewStatus = data.managerReviewStatus
    this.managerId = data.managerId
  }
}
